require('@rails/ujs').start();

document.addEventListener('ajax:complete', (event) => {
  const detail = event.detail || [];
  const xhr = detail[0];
  if (!xhr || typeof xhr.getResponseHeader !== 'function') return;

  const redirectUrl = xhr.getResponseHeader('X-Ajax-Redirect-Url');
  if (redirectUrl) {
    window.location.pathname = redirectUrl;
  }
});

document.addEventListener('ajax:error', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  if (!target.closest('#login-container')) return;

  const detail = event.detail || [];
  const xhr = detail[0];
  const flashLogin = document.getElementById('flash_login');
  if (flashLogin && xhr && typeof xhr.responseText === 'string') {
    flashLogin.innerHTML = xhr.responseText;
  }

  const alert = document.querySelector('.flash-login');
  if (alert) {
    alert.style.visibility = 'visible';
    alert.style.display = 'block';
  }
});
